import { SelectedExperienceType } from '../../../../types';
import { some } from '@utils/some';

export type FlattenedExperience =
  | {
      date: string;
      dateRange: string[];
      key: string;
      type: 'group';
      data: { optionGroupId: number; options: SelectedExperienceType[] };
      experienceIndex: number;
    }
  | {
      date: string;
      dateRange: string[];
      key: string;
      type: 'single';
      data: SelectedExperienceType;
      experienceIndex: number;
    };

export const flattenExperiences = (selectedExperiencesByDay: any[]): FlattenedExperience[] => {
  return selectedExperiencesByDay.flatMap(({ date, dateRange, options }, dayIndex) => {
    let experienceIndex = 0;

    // Calculate starting experienceIndex based on previous days
    for (let i = 0; i < dayIndex; i++) {
      const dayOptions = selectedExperiencesByDay[i].options || [];
      dayOptions.forEach((opt) => {
        if (opt.options && opt.options.length > 1) {
          experienceIndex += 1;
        } else if (some(opt.options)) {
          experienceIndex += opt.options.length;
        }
      });
    }

    return (options || []).flatMap((exp): FlattenedExperience[] => {
      const hasMultipleOptions = exp.options && exp.options.length > 1;

      if (hasMultipleOptions) {
        const result: FlattenedExperience = {
          date,
          dateRange,
          key: `${date}-group-${exp.optionGroupId}`,
          type: 'group' as const,
          data: exp,
          experienceIndex: experienceIndex++,
        };
        return [result];
      } else if (some(exp.options)) {
        return exp.options.map((experience): FlattenedExperience => {
          return {
            date,
            dateRange,
            key: `${date}-single-${experience.id}`,
            type: 'single' as const,
            data: experience,
            experienceIndex: experienceIndex++,
          };
        });
      }
      return [];
    });
  });
};
